/**
 * sessionAlarmMutes — silenciado de alarmas por sesión de navegador (ARS-08).
 *
 * Sin `persist`: se resetea al recargar/volver a loguearse a propósito — el
 * operador que ya vio y validó una alarma repetitiva no debe recibir aviso
 * de nuevo en la misma sesión, pero sí al volver a entrar.
 *
 * El estado expone `muted` (el dato) en vez de un método `isMuted` — un
 * consumidor que seleccionara solo el método nunca se re-renderizaría al
 * cambiar `muted`, porque la referencia del método no cambia entre `set()`.
 */
import { create } from 'zustand';

export function muteKey(canonicalId: string, code: string): string {
  return `${canonicalId}:${code}`;
}

interface SessionAlarmMutesState {
  muted: Set<string>;
  mute: (canonicalId: string, code: string) => void;
}

export const useSessionAlarmMutes = create<SessionAlarmMutesState>((set) => ({
  muted: new Set(),

  mute: (canonicalId, code) => {
    set(s => ({ muted: new Set(s.muted).add(muteKey(canonicalId, code)) }));
  },
}));

export function isSessionMuted(muted: Set<string>, canonicalId: string, code: string): boolean {
  return muted.has(muteKey(canonicalId, code));
}
